"use client";

import type { Scenario } from "@atlas/computation";

interface ScenarioToggleProps {
  value: Scenario;
  onChange: (scenario: Scenario) => void;
}

const SCENARIOS: { value: Scenario; label: string; color: string }[] = [
  {
    value: "conservative",
    label: "Conservative",
    color: "bg-blue-100 text-blue-800 border-blue-300",
  },
  {
    value: "moderate",
    label: "Moderate",
    color: "bg-green-100 text-green-800 border-green-300",
  },
  {
    value: "aggressive",
    label: "Aggressive",
    color: "bg-orange-100 text-orange-800 border-orange-300",
  },
];

export function ScenarioToggle({ value, onChange }: ScenarioToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-border bg-surface p-1">
      {SCENARIOS.map((s) => (
        <button
          type="button"
          key={s.value}
          onClick={() => onChange(s.value)}
          className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
            value === s.value
              ? `${s.color} border`
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
